import styled from 'styled-components'
import { TOPBAR_MOBILE_HEIGHT, BOTTOM_BAR_HEIGHT } from '@/v2/constants'

export const Container = styled.div`
  position: fixed;
  top: ${TOPBAR_MOBILE_HEIGHT};
  left: 0;
  right: 0;
  bottom: ${({ $keyboardHeight }) =>
    $keyboardHeight > 0 ? '0' : BOTTOM_BAR_HEIGHT};
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  z-index: 50;
  box-sizing: border-box;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  margin: 0;
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
  gap: 8px;

  @media (min-width: 768px) {
    padding: 16px 24px;
  }
`

export const Content = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export const ConversationsWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const SearchWrapper = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;

  @media (min-width: 768px) {
    padding: 16px 24px;
  }
`

export const TabsWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme?.primary?.main || '#eee'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  flex-shrink: 0;

  @media (min-width: 768px) {
    padding: 0 24px;
  }
`

export const ConversationsList = styled.div`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`

export const ConversationItem = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme?.primary?.main || '#eee'};
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background 0.2s;

  ${({ selected, theme }) =>
    selected
      ? `
    background: ${theme?.primary?.main || '#f0f0f0'};
  `
      : ''}

  &:active {
    background: ${({ theme }) => theme?.primary?.light || '#f5f5f5'};
  }

  @media (min-width: 768px) {
    padding: 16px 24px;
  }
`

export const PatientInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const LastMessageText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .last-message {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }
`

export const MessageBadge = styled.div`
  background: ${({ theme }) => theme?.primary?.main || '#1976d2'};
  color: ${({ theme }) => theme?.primary?.contrastText || '#fff'};
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
  flex-shrink: 0;
`

export const MessagesWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  height: 100%;

  @media (max-width: 768px) {
    height: 100%;
    max-height: 100%;
  }
`

export const PatientHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
  gap: 12px;

  @media (min-width: 768px) {
    padding: 16px 24px;
  }
`

export const PatientHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`

export const PatientName = styled.div`
  flex: 1;
  min-width: 0;

  h2 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const MessagesContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  min-height: 0;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const MessagesHistoryWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;

  @media (max-width: 768px) {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
`

export const RightSidebar = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
    width: 280px;
    border-left: 1px solid #eee;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex-shrink: 0;
  }
`

export const PatientInfoButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;

  &:active {
    background: #f0f0f0;
  }

  @media (min-width: 768px) {
    display: none;
  }
`

export const MobilePatientInfoOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  justify-content: flex-end;

  @media (min-width: 768px) {
    display: none;
  }
`

export const MobilePatientInfoPanel = styled.div`
  width: 85%;
  max-width: 320px;
  background: #fff;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  animation: slideIn 0.2s ease-out;

  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`

export const MobilePatientInfoHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #eee;
`

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  color: #666;
`
